import { Injectable } from '@angular/core';
import {ExcCoreModule} from 'exc-core';
import {any} from 'codelyzer/util/function';

@Injectable({
  providedIn: 'root'
})
export class FilterSortService {

  constructor() { }

  ComputeDataFilter(source: ExcFilter[], distinct: ExcFilter[]) {
    const dataFilter = {};
    distinct.forEach((obj) => {
      dataFilter[obj.Field] = [];
      ExcCoreModule.Array.GetAll(source, 'Field' , obj.Field).forEach((objdetial) => {
        dataFilter[objdetial.Field].push(objdetial.Condition);
      });
    });
    return dataFilter;
  }
  ComputeSortValue(source: ExcSort[]) {
    const sval = ['', 'asc', 'desc'];
    const dataSort = {};
    source.forEach((obj) => {
      if (obj.Value > 0) {
        dataSort[obj.Field] = sval[obj.Value];
      }
    });
    return dataSort;
  }
  ResetFilter(uiFilters: ExcFilter[], uiSort?: ExcSort[]) {
    uiFilters.forEach((obj) => { obj.UiValue = false;  if (obj.Type === 2 ) {obj.Condition.value = ''; } });
    if (uiSort && uiSort !== null) {
      uiSort.forEach((obj) => { obj.Value = obj.Default; });
    }
  }
  ApplyFilter(metaInfo: any, uiFilters: ExcFilter[], uiSort: ExcSort[]) {
    const mi = {dataSort: {}, dataFilter: {}};
    Object.assign(mi, metaInfo);
    const active_filter: ExcFilter[]  = ExcCoreModule.Array.GetAll(uiFilters, 'UiValue' , true);
    const distinct_active_filter:  any[] = ExcCoreModule.Array.DistinctObject(active_filter, 'Field');
    mi.dataFilter = this.ComputeDataFilter( active_filter, distinct_active_filter);
    mi.dataSort = this.ComputeSortValue(uiSort);
    return mi;
  }
  ApplyPresetFilter(filter: string, uiFilters: ExcFilter[]) {
    let found = false;
    let value = null;
    let flt = null;
    if (filter.indexOf('=') > 0) {
      flt = filter.substring(0, filter.indexOf('='));
      value = filter.substring(filter.indexOf('=') + 1, filter.length);
      for (const f of uiFilters) {
        if (f.Field === flt && f.Condition.value === value) {
          f.UiValue = true;
          found = true;
        }
      }
    } else {
      flt = filter;
      for (const f of uiFilters) {
        if (f.Field === flt) {
          f.UiValue = true;
          found = true;
        }
      }
    }
    return found;
  }
  ChangeSearchValue(obj: ExcFilter) {
    obj.UiValue = (obj.Condition.value.length > 0);
  }
  ChangeSortValue(obj: ExcSort, isMultiSort: boolean = true) {
    obj.Value = (obj.Value + 1) % 3;
    if (isMultiSort === false && obj.Container !== null && obj.Container.length > 0) {
       for (const x of obj.Container) {
         if (x.Field !== obj.Field) {
           x.Value = x.Default;
         }
       }
    }
  }

}
export class ExcFilter {
  Type = 1;
  Group = '';
  Field = '';
  Condition: ExcFilterCondition = new ExcFilterCondition('=', 0);
  UiName = '';
  UiCaption = '';
  Pane = ''
  UiValue: any = false;
  Container: ExcFilter[] = null;
  constructor(type: number, group: string, field: string, condition: ExcFilterCondition, name: string, caption: string, value: any, container?: ExcFilter[], pane?: string) {
    this.Type = type;
    this.Group = group;
    this.Field = field;
    this.Condition = condition;
    this.UiName = name;
    this.UiCaption = caption;
    this.UiValue = value;
    this.Container = container;
    this.Pane = pane;
  }
}
export class ExcSort {
  Field = '';
  Default: any;
  Caption = '';
  Value: any;
  Container: ExcSort[] = null;
  constructor(field: string, defaultValue: any, caption: string, value?: any, container?: ExcSort[]) {
    this.Field = field;
    this.Default = defaultValue;
    this.Caption = caption;
    this.Value = value || 0;
    this.Container = container;
  }
}
export class ExcFilterCondition {
  operator = '=';
  value: any;
  constructor(Operator: string, Value: any) {
    this.operator = Operator;
    this.value = Value;
  }
}
